export default __webpack_public_path__ + "static/media/instergram.26640386.svg";